import React from 'react';
import FullscreenProviderLicense from './fullscreenProviderLicense.js';
import FullscreenCartButton from './fullscreenCartButton.js';
import FullscreenCheckoutLink from './fullscreenCheckoutLink.js';
import LoveButton from '../item/loveButton/loveButton.js'
import FullscreenSocialDownload from './fullscreenSocialDownload.js';
import FullscreenShareButtons from './fullscreenShareButtons.js';
import { storePubSub } from '../../store/applications/consts.js';
import mobileViewTypes from 'wix-art-store-3rd-party/dist/src/sdk/mobileViewTypes';
import ProductsList from './storeMobileComponents/ProductsList.js';
import { utils } from '../../utils';

const storeComponentPosition = {
  top: 1,
  bottom: 2
};

class FullscreenStoreBottomMobileBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isStoreGallery: utils.isStoreGallery(),
      isSmallScreen: utils.isSmallScreen(),
    }
  }

  handleProviderAction(type, data) {
    if (this.props.onProviderAction) {
      this.props.onProviderAction(type, data);
    }
  }

  getStoreComponent({ type, data }) {
    let storeComponentData = { component: null, position: storeComponentPosition.top };

    switch (type) {
      case mobileViewTypes.singleProduct:
        storeComponentData.component = (<div>
          <FullscreenProviderLicense actions={this.props.actions} pricingData={data} />
          <FullscreenCartButton cartItems={this.props.cartItems} onAddToCartRequest={() => this.props.onAddToCartRequest()} styleParams={this.props.styleParams} />
        </div>);
        break;
      case mobileViewTypes.productsList:
        storeComponentData.position = storeComponentPosition.bottom;
        storeComponentData.component = (
          <ProductsList
            data={data}
            onProviderAction={(type, data) => this.handleProviderAction(type, data)}
          />
        );
        break;
      default:
        storeComponentData.component = (
          <div>
            Loading...
          </div>
        );
        break;
    }

    return storeComponentData;
  }

  render() {
    let curItem = this.props.current.item;
    let isImage = (curItem.type == ('image' || 'picture'));
    const { isStoreGallery, isSmallScreen } = this.state;
    const { providerView } = this.props;
    let selectedLicense = null,
      shopButtons = null;

    if (isImage) {
      selectedLicense = this.getStoreComponent(providerView || {});
      shopButtons = (<FullscreenCheckoutLink cartItems={this.props.cartItems} onClick={() => {Wix.PubSub.publish(storePubSub.checkout, {}, false);}} />);
    }

    var titleText = curItem.title || curItem.fileName || ''; //(curItem.isDemo ? curItem.demoTitle : ''); - remove default text from demo items until rewritten
    var title = (titleText && this.props.styleParams.allowTitleExpand) ? (<div className="fullscreen-side-bar-title">
      {titleText}
    </div>) : '';

    var descriptionText = curItem.description || ''; //(curItem.isDemo ? curItem.demoDescription : ''); - remove default text from demo items until rewritten
    var descriptionTextArray = descriptionText.split('\n');
    var description;
    if (descriptionText && this.props.styleParams.allowDescriptionExpand) {
      var descriptionElementsArray = [];
      for (let i = 0; i < descriptionTextArray.length; i++) {
        descriptionElementsArray.push(<div className="fullscreen-side-bar-description-line" key={"description_" + i}>
          {descriptionTextArray[i]}
        </div>)
      }

      description = (<div className="fullscreen-side-bar-description">
        {descriptionElementsArray}
      </div>)
    } else {
      description = '';
    }

    var linkClassNames = "fullscreen-side-bar-link link" + (isStoreGallery ? ' store' : '')
    var link = (curItem.linkUrl && this.props.styleParams.allowLinkExpand) ? (
      curItem.linkType === 'web' ? (
        <a className={linkClassNames}
           href={curItem.linkUrl}
           target={curItem.linkOpenType}>
          {curItem.linkText ? curItem.linkText : curItem.linkUrl}
        </a>
      ) : (
        <div
          className={linkClassNames}
          onClick={() => this.props.actions.navigateToPageByItemLink(curItem)}>
          {curItem.linkText ? curItem.linkText : curItem.linkUrl}
        </div>)
    ) : '';

    const shouldRenderSelectedLicenseOnTop = selectedLicense && (selectedLicense.position === storeComponentPosition.top);
    const shouldRenderSelectedLicenseOnBottom = selectedLicense && (selectedLicense.position === storeComponentPosition.bottom);

    return (
      <div
        className={"fullscreen-bottom-mobile-info" + (isStoreGallery ? ' store' : '')}
        style={{textAlign: this.props.styleParams.galleryAlignExpand}}>
        {shouldRenderSelectedLicenseOnTop ? selectedLicense.component : null}
        {shopButtons}
        <div className={"fullscreen-side-bar-info-container" + (isStoreGallery ? ' store' : '')}>
          <div ref={itemContainer => { this.itemContainer = itemContainer } }>
            {title}
            {description}
          </div>
          {link}
        </div>
        {shouldRenderSelectedLicenseOnBottom ? selectedLicense.component : null}
      </div>
    );
  }
}

export default FullscreenStoreBottomMobileBar;



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenStoreBottomMobileBar.js